// extracted by mini-css-extract-plugin
module.exports = {"main":"AvailabilityResult_main__3rHkx","filters":"AvailabilityResult_filters__pnu4T","hotels":"AvailabilityResult_hotels__d2RVJ","hotel":"AvailabilityResult_hotel__JjnWE"};